import { render, staticRenderFns } from "./KBInvoicesList.vue?vue&type=template&id=51c406d4&"
import script from "./KBInvoicesList.vue?vue&type=script&lang=ts&"
export * from "./KBInvoicesList.vue?vue&type=script&lang=ts&"
import style0 from "./KBInvoicesList.vue?vue&type=style&index=0&id=51c406d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports